import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { RegExpIsFloat } from './../_const/const';
import { EditorService } from '@service/editor.service';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
// import form_template from '@angular/forms';

@Component({
    selector: 'inputindex',
    templateUrl: 'inputindex.component.html',
    styleUrls: ['inputindex.component.scss'],
})
export class InputIndexComponent implements OnInit, OnChanges {
    @Input() public dataVariableList;
    @Input() public libCol_1: string;
    @Input() public libCol_2: string;
    @Input() public btnUpdate: boolean = false;

    @Output()
    public onUpdate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onSetConfirm: EventEmitter<any> = new EventEmitter();

    public form: FormGroup;
    public fields: any[] = [];
    // public fr: any;
    public isFloat: any;
    private formCreate: boolean = false;
    private updated: boolean = false;

    public items: FormArray;

    constructor(private editorService: EditorService, private formBuilder: FormBuilder) {
        // console.log('input constructor', this.dataVariableList);
    }

    public ngOnInit() {
        // this.fr = DayMonth;
        // console.log('ngOnInit')
        this.isFloat = RegExpIsFloat;
        // console.log('input ngOnInit', this.dataVariableList);
    }

    public ngOnChanges() {
        console.log('ngOnChanges');
        if (this.dataVariableList !== undefined) {
            this.formCreate = false;
            this.updated = false;
            console.log('input ngOnChanges in');
            this.updateVariable(this.dataVariableList);
            this.form = this.formBuilder.group({
                items: this.formBuilder.array([]),
            });
            this.form.valueChanges.subscribe((change) => {
                if (this.formCreate) {
                    this.updated = true;
                    this.onSetConfirm.emit();
                    this.updateVariableChange(change);
                    // console.log(change);
                }
            });
            this.createFormGroup(this.dataVariableList);
            // console.log('input ngOnChanges fields', this.fields);
        }
    }

    private createFormGroup(aData) {
        let wField: any;
        this.fields = [];
        aData.forEach((item) => {
            wField = null;
            switch (item.type) {
                case 'separator': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: item.value,
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }
                case 'DateTime':
                case 'Date': {
                    if (item.name === 'Var1') {
                        console.log('item', item.type, item.name, item.value);
                    }
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: item.value,
                        disabled: item.disabled,
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }
                case 'Combo': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: '', // this.editorService.getValueFromCombo(item),
                        options: [item.comboValue],
                        editable: item.editable,
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                        valueCombo: '',
                    };
                    break;
                }
                case 'ComboCustom': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: '', //this.editorService.getValueFromCombo(item),
                        options: [item.comboValue],
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }
                case 'ListUsers': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: '', //this.editorService.getValueFromCombo(item),
                        options: [item.comboValue],
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }
                case 'ListGroups': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: '', //this.editorService.getValueFromCombo(item),
                        options: [item.comboValue],
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }                
                case 'ListDB': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: '',
                        options: [item.comboValue],
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }
                // case 'DynamicIndex': {
                //   wField =  new Object();
                //   wField = {
                //     type: 'dropdown',
                //     name: item.name,
                //     label: item.label,
                //     value: item.value,
                //     options: item.comboValue
                //   };
                //   break;
                // }
                case 'String': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: item.value,
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }
                case 'Integer': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: item.value,
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }
                case 'Double': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: item.value,
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }
                case 'EditMask': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: item.value,
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }
                case 'Boolean': {
                    wField = new Object();
                    wField = {
                        type: item.type,
                        name: item.name,
                        label: item.label,
                        value: item.valueCombo,
                        visible: item.visible,
                        system: item.system,
                        required: item.required,
                    };
                    break;
                }
                default:
                    console.log('def');
                    // wRes = null;
                    break;
            }
            if (wField !== null) {
                this.fields.push(wField);
            }
        });

        this.items = this.form.get('items') as FormArray;

        this.fields.forEach((field) => {
            this.items.push(this.formBuilder.group(field));
        });
        this.formCreate = true;
    }

    public update() {
        if (this.updated) {
            this.onUpdate.emit();
            this.updated = false;
        }
    }

    private updateVariableChange(aVarList) {
        this.editorService.varListSave = aVarList;
    }

    private updateVariable(data) {
        // console.log('input updateVariable', this.dataVariableList);
        this.editorService.updateVariable(data);
    }

    public onChange($event, item, index) {
        // A implémenter pour index dynamique
        // console.log('input onChange', item, index);
        // this.dataVariableList = this.editorService.changeVar(item, this.dataComboList);
    }

    public onChangeCmbEditable($event, item, index) {
        // console.log('input onChangeCmbEditable', $event,  item, index);
        item.value = $event.value;
    }

    public onValueChange(item, index) {
        // console.log('input onValueChange', item, index);
    }
}
